import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { LOCALE_ID, inject } from '@angular/core';
import { Observable } from 'rxjs';

export function localeInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  let locale = inject(LOCALE_ID);

  if (locale?.length > 2) {
    locale = locale.substring(0, 2);
  }

  const clonedRequest = request.clone({
    headers: request.headers.set('Accept-Language', locale),
  });

  return next(clonedRequest);
}
